<template>
  <div class="bg-surface rounded-extra-large relative flex h-full grow flex-col overflow-y-auto">
    <div class="mx-auto flex w-full max-w-7xl flex-row items-center p-5">
      <slot name="hero" />
    </div>
    <div class="mx-auto h-full w-full max-w-5xl px-4 pb-8">
      <slot />
    </div>
  </div>
</template>
<script lang="ts" setup></script>
